import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "../../../util/getCustomColor";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles((theme) => ({
  select: {
    height: "40px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    color: "#667085",
    backgroundColor: (props: { disabled?: boolean }) => (props?.disabled ? "#F9FAFB" : "#FFFFFF"),
  },
  menuItem: {
    "& .MuiMenuItem-root": {
      fontFamily: "Manrope",
      fontWeight: 500,
      paddingTop: "8px",
      paddingBottom: "8px",
      color: "#667085",
    },
    "& .MuiMenuItem-root.Mui-selected": {
      backgroundColor: getBrandCustom("headerBackgroundColor", "#EDF5FB"),
      color: getBrandCustom("primaryColor", colors.brandBlue600),
      fontWeight: 600,
    },
    "& .MuiMenuItem-root:hover": {
      backgroundColor: getBrandCustom("headerBackgroundColor", "#EDF5FB"),
      color: getBrandCustom("primaryColor", colors.brandBlue600),
    },
  },
  menuItemPlaceholder: {
    backgroundColor: "transparent !important",
    opacity: "1 !important",
  },
  text: {
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  placeholder: {
    color: "#CDD1D8",
  },
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
  },
  label: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: (props: { disabled?: boolean }) =>
      props?.disabled ? "#667085" : getBrandCustom("darkPrimaryColor", colors.brandBlue600),
    marginBottom: "4px",
    gap: "4px",
  },
  required: {
    color: (props: { disabled?: boolean }) => (props?.disabled ? "#667085" : "#F04438"),
  },
  tooltip: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginTop: 1,
    color: "#465869",
    cursor: "help",
    marginLeft: "8px",
  },
  selectIcon: {
    top: "50%",
    transform: "translateY(-50%)",
    right: "7px",
    position: "absolute",
    color: "#667085 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default styles;
